import React, { FunctionComponent } from 'react';
import classnames from 'classnames';

import styles from './_WaitingBadge.module.css';

interface Props {
    text: string;
    viewVariant: 'default' | 'waitingEnd' | 'unwatchable';
}

export const WaitingBadge: FunctionComponent<Props> = ({ text, viewVariant }) => (
    <div
        className={classnames(styles.root, {
            [styles.rootWaitingEnd]: viewVariant === 'waitingEnd',
        })}
    >
        <div
            className={`${styles.icon} ${
                viewVariant === 'default' || viewVariant === 'waitingEnd' ? styles.iconClock : ''
            } ${viewVariant === 'unwatchable' ? styles.iconWarning : ''}`}
        />
        {text}
    </div>
);
